import get from 'lodash/get';
import { connect } from 'react-redux';

import AnswerDisplay from 'presentation/components/__demo__/AnswerDisplay';
import { updateSelectedAnswer } from 'app/modules/knowledge_base/demo';
import { getSelectedAnswer } from 'app/modules/';

export const mapStateToProps = state => {
  let selectedAnswer = getSelectedAnswer(state);

  return {
    name: get(selectedAnswer, 'name'),
    body: get(selectedAnswer, 'content.public.bodyHtml'),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => {
      dispatch(
        updateSelectedAnswer({
          selectedResultAnswerId: '',
        })
      );
    },
  };
};

const AnswerDisplayContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnswerDisplay);

export default AnswerDisplayContainer;
